import { GetterTree } from 'vuex';

import {
  CalendarStateI,
  CalendarI,
} from './state';
import { RootStateI } from '../state';

function isSameCalendarId(
  left: number | string,
  right: number | string,
) {
  return String(left) === String(right);
}

export const getters: GetterTree<CalendarStateI, RootStateI> = {
  visibleCalendars(state: CalendarStateI): CalendarI[] {
    return state.calendars.filter((calendar) => (
      !state.hiddenCalendarIds.some((hiddenId) => (
        isSameCalendarId(hiddenId, calendar.id)
      ))
    ));
  },
  visibleCalendarIds(
    _state: CalendarStateI,
    localGetters,
  ): Array<number | string> {
    return (localGetters.visibleCalendars as CalendarI[])
      .map((calendar) => calendar.id);
  },
  isCalendarVisible: (state: CalendarStateI) => (
    calendarId: number | string,
  ): boolean => (
    !state.hiddenCalendarIds.some((hiddenId) => (
      isSameCalendarId(hiddenId, calendarId)
    ))
  ),
};
